import {
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  fraDato: "",
  tilDato: "",
  submitTimestamp: "",
};

export default function antallIleggelserPerIleggelsetypeSubmittedFormReducer(
  state = {
    ...INITIAL_STATE,
  },
  action,
) {
  switch (action.type) {
    case handleChangeAllActionType(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_SUBMITTED_FORM",
    ):
      return { ...action.payload };
    case handleChangeToInitStateActionType(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_SUBMITTED_FORM",
    ):
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}
